import fetch from 'tools/fetch'
import {
  postShortLivedTokenPath,
  getLongLivedTokenPath,
  getIgUserInfoPath,
  getIgUserMediaPath
} from './server'

const makeOptions = ({ method = 'GET', payload }) => ({
  method,
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(payload)
})

export const instagramApi = ({ origin, igApiRoot }) => {
  // https://developers.facebook.com/docs/instagram-basic-display-api/getting-started
  const postShortLivedTokenApi = async ({ payload, req }) => fetch(
    `${origin(req)}${igApiRoot}${postShortLivedTokenPath}`,
    makeOptions({ method: 'POST', payload }),
    true
  )

  // https://developers.facebook.com/docs/instagram-basic-display-api/reference/access_token
  const getLongLivedTokenApi = async ({ shortLivedToken, req }) => fetch(
    `${origin(req)}${igApiRoot}${getLongLivedTokenPath}?access_token=${shortLivedToken}&grant_type=ig_exchange_token`,
    makeOptions({ method: 'GET' }),
    true
  )

  // https://developers.facebook.com/docs/instagram-basic-display-api/reference/me
  const getIgUserInfoApi = async ({ igToken, fields = 'id,username', req }) => fetch(
    `${origin(req)}${igApiRoot}${getIgUserInfoPath}?access_token=${igToken}&fields=${fields}`,
    makeOptions({ method: 'GET' }),
    true
  )

  // https://developers.facebook.com/docs/instagram-basic-display-api/reference/media
  const getIgUserMediaApi = async ({ igToken, fields = 'id,media_url,media_type,username,permalink', after = '', req }) => fetch(
    `${origin(req)}${igApiRoot}${getIgUserMediaPath}?access_token=${igToken}&fields=${fields}&after=${after}`,
    makeOptions({ method: 'GET' }),
    true
  )

  return {
    /** Authentication */
    postShortLivedTokenApi,
    getLongLivedTokenApi,

    /** User info */
    getIgUserInfoApi,

    /** User media */
    getIgUserMediaApi
  }
}
